import script from "./asidebarMenuMobileApp.vue?vue&type=script&setup=true&lang=js"
export * from "./asidebarMenuMobileApp.vue?vue&type=script&setup=true&lang=js"

import "./asidebarMenuMobileApp.vue?vue&type=style&index=0&id=f9e5d6b6&scoped=true&lang=css"

import exportComponent from "/builds/portal-da-transparencia/cge-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9e5d6b6"]])

export default __exports__